import { http } from 'connex-cds';

export default {
  getMasterData: ({ entityRef, typeId }) => http.get({ apiName: 'setup', path: `/${entityRef}/items/${typeId}` }),
  updateMasterData: ({ entityRef, typeId, item }) =>
    http.patch({ apiName: 'setup', path: `/${entityRef}/items/${typeId}/${item?.crn}`, data: item }),
  createMasterData: ({ entityRef, typeId, item }) =>
    http.post({ apiName: 'setup', path: `/${entityRef}/items/${typeId}`, data: item }),
};
